
import { Options, Vue } from "vue-class-component"; //基本需要\
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readDateVersions,
  readNewReport,
  readNewReportList,
  // readPerfReport,
  readLabelReport,
  readRecentTaskrecord,
  readTaskRecordDevices,
  readTaskRecordQuery,
  readPerformanceVersion,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchCreateReport,
  // dispatchGetPerfReport,
  dispatchGetLabelReport,
  dispatchGetReportDetail,
  // dispatchGetPerformances,
  dispatchUploadReportImage,
  dispatchtaskRecordDevices,
  dispatchGetNewReportList,
  dispatchDeleteReport,
  dispatchGetDateVersionList,
  dispatchRecentTaskrecord,
  dispatchCreateReportByTask,
  dispatchUpdateReport,
  dispatchtaskRecordQuery,
  dispatchAovCopyPerfToReport,
  dispatchGetPerformanceVersion,
  dispatchClearCache,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReport extends Vue {
  //声明属性
  public contrast = true;
  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; //报告的id
  public com_risk = "低风险"; //共同风险
  public loading = false; //加载
  public FPStrendShow = true;
  //新报告数据类型
  public new_report: any = {
    //新报告需要的数据类型
    id: 0,
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        tdr_risk_rule: {},
      },
      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
          core_color_rule: false, // 核心指标标红规则, 1:变差就标红, 0: 超过阈值才标红
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
    creator: "",
  };
  //获取核心数据的数据类型
  public get_core_data = {
    able_versions: {
      android_new_version: "",
      android_old_version: "",
      ios_new_version: "",
      ios_old_version: "",
    },
    auto_roadmap: {},
    report_data: {},
    report_list: [],
    report_list1: [],
    new_version: "",
    old_version: "",
    old_version1: "",
    all_devices: [],
    report_list2: [
      {
        scene_id: 0,
        scene: "",
        old_version: "",
        custom_index: [],
        device_list: [],
        old: [
          {
            data: { url: "", game_version: "" },
          },
        ],
        new: [
          {
            data: { url: "", game_version: "" },
          },
        ],
        standard: [],
      },
    ],
    all_echart_versions: [],
    all_echart_data: [
      {
        performance_briefs: [{ device_id: 0 }],
        date_list: [],
        // echart_data: [],
        echart_data: {
          series: [],
          device_names: [],
          x_axis_format: [],
        },
      },
    ],
    project: {
      icon: "",
      project_name: "",
    },
    all_device_id: [],
    str_list: [],
    hero_list: [],
    skin_list: [],
    all_hero_skins: {},
    core_devices1: [],
    core_devices2: [],
    real_scenes: [],
    version_comparison_list: [],
    position: [],
    device_options: [],
  };

  public get_field(field: string) {
    const fields = {
      avg_fps: "平均FPS", // 平均FPS
      avg_pss: "均值PSS",
      max_pss: "峰值PSS", // 峰值PSS
      max_mono_used: "maxMonoUsed(M)", // 峰值Used Mono
      max_mono_total: "峰值mono内存(M)", // 峰值Total Mono
      avg_cpu: "平均CPU", // 平均CPU
      fps_lt_10_pcnt: "FPS<=10占⽐(%)", // FPS<=10占有率(%)
      fps_lt_18_pcnt: "FPS>=18占⽐(%)", // FPS>=18占有率(%)
      fps_lt_25_pcnt: "FPS>=25占⽐(%)", // FPS>=25占有率(%)
      fps_lt_40_pcnt: "FPS>=40占⽐(%)", // FPS>=40占有率(%)
      cpu_lt_60_pcnt: "CPU<=60占⽐(%)", // FPS<=60占有率(%)
      cpu_lt_80_pcnt: "CPU<=80占⽐(%)", // FPS<=80占有率(%)
      dps: "dps",
      avg_dc: "平均DC", // 平均DC
      max_dc: "峰值DrawCall数", // 峰值DC
      max_triangle: "峰值三角形数", // 峰值三角形(万)
      duration: "耗时", // 耗时
      avg_flow: "流量(KB/S)", // 流量(KB/S)
      max_swap: "maxSwap",
      max_vss: "maxVss",
      max_swap_add_pss: "maxSwapAddPss",
      process_up_flow: "进程上行流量[KB/s]",
      process_down_flow: "进程下行流量[KB/s]",
      logic_up_flow: "逻辑上行流量[KB/s]",
      logic_down_flow: "逻辑下行流量[KB/s]",
      lag_cnt: "卡顿次数", // 卡顿次数
      single_peak_lag_cnt: "singlePeakLagCnt",
      multiple_peak_lag_cnt: "multiplePeakLagCnt",
      continue_low_lag_cnt: "continueLowLagCnt",
      lag_pcnt: "卡顿率", // 卡顿率
      lag_freq: "卡顿频率",
      id_row_start: "id_row_start",
      id_row_end: "id_row_end",
      id_frame_start: "id_frame_start",
      id_frame_end: "id_frame_end",
      avg_cpu_total: "avgCpuTotal",
      gc_cnt: "GC(次)", // gc_cnt
      gc_freq: "GC频率",
      cpu_temp: "CPU温度",
    };
    return typeConversion(field, fields, true); //类型转换
  }
  //获取场景iD
  public selected_scene =
    (this.get_core_data.all_echart_data as any[])[0]?.scene_id || "";
  public selected_scene1 =
    (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
  //
  // 页面初始化
  public async mounted() {
    this.loading = true;

    if (this.$route.query.report_id) {
      if (this.$route.query.project) {
        const project = Number(this.$route.query.project);
        // 记录一下最后访问的项目
        dispatchUpdateMyLastProject(store, { last_visit_project: project });
        saveLocalProject(String(project));
        saveLocalStorageProject(String(project));
        dispatchGetDeviceSpecs(store, {
          project: project,
        });
        dispatchGetDateVersionList(store, {
          project: project,
        });
        dispatchRecentTaskrecord(store, { project: project }); //表格对应label
        this.reload();
        // 获取当前报告名称列表
        await dispatchGetNewReportList(store, {
          project: this.localProject,
          report_type: 0,
        });
        (this.name_search as any) = Number(this.$route.query.report_id);
        await dispatchGetMobaProjects(store, project);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, project);
        }
        await dispatchGetReportDetail(store, {
          project: project,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetLabelReport(store, {
          project: project,
          report_id: Number(this.$route.query.report_id),
        });
        // await this.showEdit();
        await this.perf_report();
        this.scene_options; //选择场景
        this.selected_device = this.get_core_data.all_devices[0] || "";
        await this.get_create_report(); //启用生成报告的接口
        this.selected_scene =
          (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
        if (this.get_core_data.auto_roadmap != undefined) {
          this.selected_scene1 =
            (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
          this.imgData = readLabelReport(store).auto_roadmap[0]?.roadmap;
          // this.imgData=[{device_name: "19X",fps: require("../../assets/test/1.jpg"),trajectory: "",}]
        }
        if (
          this.get_core_data.position.length > 0 &&
          this.get_core_data.position != undefined
        ) {
          // this.selected_scene2 = (
          //   this.get_core_data.position[0] as any
          // )?.scene_id;
          // let sceneModelList: any = [];
          // sceneModelList.push({
          //   scene_id: (this.get_core_data.position[0] as any)?.position[0]
          //     .device_id,
          //   chinese: (this.get_core_data.position[0] as any)?.position[0]
          //     .device,
          // });

          // this.sceneModelOption = sceneModelList;
          // this.selected_scene3 = (
          //   this.get_core_data.position[0] as any
          // )?.position[0]?.device_id;
          this.selected_scene3 = (this.get_core_data
            .device_options[0] as any).id;
          this.selected_scene4 = this.indexOption[0];
        }

        if (this.report_set.content.trend_scene) {
          if (this.report_set.content.trend_scene.length !== 0) {
            this.selected_scene = this.report_set.content.trend_scene[0];
          }
        }

        this.resBase64 = [];
        this.target_types.map((item, index) => {
          this.drawPieChart(index, item.value);
          let performanceTrends: any = document.getElementById(
            "performance_line" + index
          );
          if (performanceTrends.children.length === 0) {
            performanceTrends.parentNode.parentNode.parentNode.style.display =
              "none";
            // performanceTrends.parentNode.style.display="block"
          } else {
            performanceTrends.parentNode.parentNode.parentNode.style.display =
              "block";
          }
        });

        // await this.drawMap(
        //   this.selected_scene2,
        //   this.selected_scene3,
        //   this.selected_scene4,
        //   this.indexValue
        // );

        await this.getDiagramList().map((v: any) => {
          if (this.typeValue == true) {
            this.fal = true;
            this.fal1 = false;
          } else {
            this.fal1 = true;
            this.fal = false;
          }
          this.$nextTick(() => {
            this.drawMap3(
              v.mapName,
              v.idIndex,
              this.selected_scene4,
              this.indexValue,
              this.selected_scene3,
              this.typeValue
            );
          });
        });
        if (readLabelReport(store).auto_roadmap != undefined) {
          // this.imgData=[{device_name: "19X",fps: "../../assets/performance/footer.png",trajectory: "",}]
        }

        //     console.log(this.get_core_data
        // .all_echart_data.length)
        // if(this.get_core_data
        // .all_echart_data.length<=0){
        //   this.ecShow=false
        // }
        if (this.localProject === 8) {
          this.drawcontrastChart();
          this.drawcontrastChart2();
        }
        // 从浏览器触发发送报告
        if ("screenshot" in this.$route.query) {
          this.save_report();
        }
      } else {
        dispatchGetDeviceSpecs(store, {
          project: this.localProject,
        });
        dispatchGetDateVersionList(store, {
          project: this.localProject,
        });
        dispatchRecentTaskrecord(store, { project: this.localProject }); //表格对应label
        await dispatchGetMobaProjects(store, this.localProject);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, this.localProject);
        }
        await dispatchGetReportDetail(store, {
          project: this.localProject,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetLabelReport(store, {
          project: this.localProject,
          report_id: Number(this.$route.query.report_id),
        });

        await this.perf_report();
        this.scene_options; //选择场景
        await this.get_create_report(); //启用生成报告的接口
        await dispatchGetProjectScenes(store, { project: this.localProject });
        this.selected_scene =
          (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
        if (this.get_core_data.auto_roadmap != undefined) {
          this.selected_scene1 =
            (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
          this.imgData = readLabelReport(store).auto_roadmap[0]?.roadmap;
          // this.imgData=[{device_name: "19X",fps: "../../assets/performance/footer.png",trajectory: "",}]
        }
        if (
          this.get_core_data.position.length > 0 &&
          this.get_core_data.position != undefined
        ) {
          // this.selected_scene2 = (
          //   this.get_core_data.position[0] as any
          // )?.scene_id;
          // let sceneModelList: any = [];
          // sceneModelList.push({
          //   scene_id: (this.get_core_data.position[0] as any)?.position[0]
          //     .device_id,
          //   chinese: (this.get_core_data.position[0] as any)?.position[0]
          //     .device,
          // });
          // this.sceneModelOption = sceneModelList;
          // this.selected_scene3 = (
          //   this.get_core_data.position[0] as any
          // )?.position[0]?.device_id;
          // this.selected_scene4 = this.indexOption[0];
        }
        if (this.report_set.content.trend_scene) {
          if (this.report_set.content.trend_scene.length !== 0) {
            this.selected_scene = this.report_set.content.trend_scene[0];
          }
        }
        this.resBase64 = [];
        this.target_types.map((item, index) => {
          this.drawPieChart(index, item.value);
        });

        // await this.drawMap(
        //   this.selected_scene2,
        //   this.selected_scene3,
        //   this.selected_scene4,
        //   this.indexValue
        // );
        this.getDiagramList().map((v: any) => {
          if (this.typeValue == true) {
            this.fal = true;
            this.fal1 = false;
          } else {
            this.fal1 = true;
            this.fal = false;
          }
          this.$nextTick(() => {
            this.drawMap3(
              v.mapName,
              v.idIndex,
              this.selected_scene4,
              this.indexValue,
              this.selected_scene3,
              this.typeValue
            );
          });
        });
        if (this.localProject === 8) {
          this.drawcontrastChart();
          this.drawcontrastChart2();
        }
      }
    } else {
      dispatchGetDateVersionList(store, {
        project: this.localProject,
      });
      dispatchRecentTaskrecord(store, { project: this.localProject }); //表格对应label
      // 获取当前报告名称列表
      await dispatchGetNewReportList(store, {
        project: this.localProject,
        report_type: 0,
      });
      // 报告名称
      (this.name_search as any) = readNewReportList(store)[0].id;

      this.$router.push({
        query: { ...this.$route.query, report_id: this.name_search },
      });
      // (this.name_search as any) = this.$route.query.report_id;
      // 邮件标题
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.name_search
      )[0].report_name;
      // 邮件收件人
      // 获取当前报告数据
      await dispatchGetReportDetail(store, {
        project: this.localProject,
        id: Number(this.name_search),
      });
      //调用获取性能报告接口
      await dispatchGetLabelReport(store, {
        project: this.localProject,
        report_id: Number(this.name_search),
      });
      await dispatchGetProjectDetail(store, {
        id: this.localProject,
        project: this.localProject,
      });
      //启用生成报告的接口
      await this.get_create_report();
      await this.perf_report();
      this.selected_scene =
        (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
      if (this.get_core_data.auto_roadmap != undefined) {
        this.selected_scene1 =
          (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
        this.imgData = readLabelReport(store).auto_roadmap[0]?.roadmap;
        // this.imgData=[{device_name: "19X",fps: "../../assets/performance/footer.png",trajectory: "",}]
      }
      if (
        this.get_core_data.position.length > 0 &&
        this.get_core_data.position != undefined
      ) {
        this.selected_scene3 = (this.get_core_data.device_options[0] as any).id;
        this.selected_scene4 = this.indexOption[0];
      }
      if (this.report_set.content.trend_scene) {
        if (this.report_set.content.trend_scene.length !== 0) {
          this.selected_scene = this.report_set.content.trend_scene[0];
        }
      }
      this.resBase64 = [];
      this.target_types.map((item, index) => {
        this.drawPieChart(index, item.value);
      });

      // await this.drawMap(
      //   this.selected_scene2,
      //   this.selected_scene3,
      //   this.selected_scene4,
      //   this.indexValue
      // );
      this.getDiagramList().map((v: any) => {
        if (this.typeValue == true) {
          this.fal = true;
          this.fal1 = false;
        } else {
          this.fal1 = true;
          this.fal = false;
        }
        this.$nextTick(() => {
          this.drawMap3(
            v.mapName,
            v.idIndex,
            this.selected_scene4,
            this.indexValue,
            this.selected_scene3,
            this.typeValue
          );
        });
      });
      if (this.localProject === 8) {
        this.drawcontrastChart();
        this.drawcontrastChart2();
      }
      // 从浏览器触发发送报告
      if ("screenshot" in this.$route.query) {
        this.save_report();
      }
    }
    if (this.localProject !== 8) {
      this.FPStrendShow = false;
    }
    this.judgeModel();

    await this.addressee; //解析邮件收件人
    await this.getCorePerformance();

    this.new_risk();
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备
    await this.scrollBar(); //判断是否有滚动条
    // this.drawTest()
    this.loading = false;
  }
  public drawTest(
    item1: any,
    index1: any,
    indexName1: any,
    indexvalue: any,
    modelID1: any
  ) {
    var chartDom = document.getElementById("map1" + item1) as HTMLElement;
    var contrastChart = echarts.init(chartDom);
    let indexMap = 0;
    if (this.indexOption.indexOf(indexName1) != -1) {
      indexMap = this.indexOption.indexOf(indexName1) + 2;
    }
    // let dataAll=[]
    const data = (this.get_core_data.position[index1] as any).position
      .filter((v: any) => v.device_id == modelID1)[0]
      ?.chart.map(function (item: any) {
        return [item[1], item[0], item[indexMap] || "-"];
      });
    //    let xData = [];
    // let yData = [];
    // for(let i=0;i<=200;i++){
    //   xData.push(i)
    //     }

    //     for(let i=0;i<=150;i++){
    //       yData.push(i)
    //     }
    const xData = (this.get_core_data.position[index1] as any).position.filter(
      (v: any) => v.device_id == modelID1
    )[0]?.x;
    // prettier-ignore
    const yData = (this.get_core_data.position[index1] as any).position.filter((v:any)=>v.device_id==modelID1)[0]?.y;
    let labelShow = true;
    let fullImage = new Image();
    let img = new Image();
    let min = 0;
    let max = 0;
    let imgColor = [];
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");

    canvas.width = contrastChart.getWidth() * window.devicePixelRatio;
    canvas.height = contrastChart.getHeight() * window.devicePixelRatio;
    img.onload = () => {
      (ctx as any).drawImage(img, 0, 0, canvas.width, canvas.height);
      fullImage.src = canvas.toDataURL();
      contrastChart.resize();
    };
    if (item1.indexOf("森林") != -1) {
      img.src = require("../../assets/test/003.jpg");
    } else if (item1.indexOf("航天") != -1) {
      img.src = require("../../assets/test/006.jpg");
    } else if (item1.indexOf("cracked") != -1) {
      img.src = require("../../assets/test/005.jpg");
    } else {
      img.src = require("../../assets/test/002.jpg");
    }
    if (indexName1 === "平均FPS") {
      labelShow = true;
      max = indexvalue;
      min = Number(max) - 1;
      imgColor = ["rgba(255,0,0,0.5)", "rgba(0,255,0,0.5)"];
    } else {
      labelShow = false;
      min = indexvalue;
      max = Number(min) + 1;
      imgColor = ["rgba(0,255,0,0.5)", "rgba(255,0,0,0.5)"];
    }

    // function generateData(theta, min, max) {
    //   let data = [];
    //   for (let i = 0; i <= 200; i++) {
    //     for (let j = 0; j <= 100; j++) {
    //       // let x = (max - min) * i / 200 + min;
    //       // let y = (max - min) * j / 100 + min;
    //       data.push([i, j, noise.perlin2(i / 40, j / 20) + 0.5]);
    //       // data.push([i, j, normalDist(theta, x) * normalDist(theta, y)]);
    //     }
    //     xData.push(i);
    //   }
    //   for (let j = 0; j < 100; j++) {
    //     yData.push(j);
    //   }
    //   console.log(xData)
    //   console.log(yData)
    //   console.log(data)
    //   return data;
    // }

    let option = {};

    option = {
      grid: {
        x: 0,
        y: 0,
        x2: 0,
        y2: 0,
      },
      xAxis: {
        type: "category",
        data: xData,
      },
      yAxis: {
        type: "category",
        data: yData,
      },
      visualMap: {
        min: min,
        max: max,
        calculable: true,
        realtime: false,
        show: false,
        inRange: {
          color: imgColor,
        },
      },
      backgroundColor: {
        image: fullImage,
        repeat: "no-repeat",
      },
      tooltip: {
        position: "top",
        // formatter: function (params: any, ticket: any, callback: any) {
        //   console.log(params);
        //   var showHtm = "";
        //   console.log(1);

        //   // return `<div>${params.seriesName}:${params.data[2]}</div>`;
        //   return <img src="../../assets/test/2.jpg"/>;
        // },
        formatter: function (params: any) {
          return `<div>${params.seriesName}:${params.data[2]}</div>`;
          //         console.log(params);
          //           var str = `<div style = "background:url( ${require("../../assets/test/8.jpg")}) no-repeat center center ;width:60px;height:60px; "></div>`;

          // console.log(str);
          // return str;
          //  return  `<div style="display:flex"><div style = "background:url(${require("../../assets/test/8.jpg")}) no-repeat center center ;width:200px;height:200px;margin-right:10px;background-size:100% 100% "></div><div style = "background:url(${require("../../assets/test/9.jpg")}) no-repeat center center ;width:200px;height:200px;background-size:100% 100% "></div></div>`

          // <div>

          // `;
        },
      },
      series: [
        {
          name: indexName1,
          type: "heatmap",
          data: data,
          // emphasis: {
          //   itemStyle: {
          //     borderColor: '#333',
          //     borderWidth: 1
          //   }
          // },
          progressive: 1000,
          animation: false,
        },
      ],
    };
    contrastChart.setOption(option);
  }
  //性能报告核心数据
  public perf_report() {
    this.get_core_data = readLabelReport(store);
  }
  //获取新报告数据
  public get_create_report() {
    this.new_report = readNewReport(store);
    this.new_report.create_date = dateConversion(this.new_report.create_date);
  }
  // 核心指标风险详情
  public corePerformance: any[] = [];
  // 核心指标性能数据
  public getCorePerformance() {
    if (this.get_core_data.report_list.length > 0) {
      this.corePerformance.push({
        title: "新场景:",
        data: this.get_core_data.report_list,
        compare: this.get_core_data.core_devices1,
        edition: this.get_core_data.old_version,
      });
    }
    if (this.get_core_data.report_list1.length > 0) {
      this.corePerformance.push({
        title: "老场景:",
        data: this.get_core_data.report_list1,
        compare: this.get_core_data.core_devices2,
        edition: this.get_core_data.old_version1,
      });
    }

    return this.corePerformance;
  }

  //将新报告的JSON 字符串转换为对象。
  public get report_set() {
    const settings = JSON.parse(this.new_report.settings);

    return settings.report_settings;
  }
  public imgData: any = [];
  // 数值变化的规则配置
  public get rule_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.rule_settings;
  }
  // 趋势对比
  public compore_num(
    new_value: number,
    old_value: number,
    param: string,
    row?: any,
    device?: any
  ) {
    let level = device?.level;
    let device_type = device?.type;
    if (device_type === 0) {
      device_type = "Android";
    } else if (device_type === 1) {
      device_type = "iOS";
    }
    if (!new_value) {
      return ["", "", ""];
    }
    let res: any = 0;
    if (old_value) {
      res = parseFloat((new_value - old_value).toFixed(1));
    }

    let risk = "";
    let color = ""; // 核心表格差值颜色
    let style = ""; // 核心表格原值颜色
    let new_color = ""; //详情表格差值颜色
    let is_rule = false;
    if (res !== 0) {
      // 风险判断,在increase_good中的上升标为绿色，下降为红色，如果配置有threshold，则变动超出阈值才标记颜色
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        // 风险评估阈值(变化值)
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            typeof this.rule_set.risk_rule?.[param] !== "number" &&
            this.rule_set.risk_rule?.[param].search("%") !== -1
          ) {
            // 阈值类型为百分比: 5%
            if (
              (old_value - new_value) / old_value >
              Number(
                this.rule_set.risk_rule?.[param].substring(
                  0,
                  this.rule_set.risk_rule?.[param].indexOf("%")
                )
              ) *
                0.01
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          } else {
            // 阈值类型为绝对值: 32
            if (
              old_value - new_value >
              Number(this.rule_set.risk_rule?.[param])
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          }
        }
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 颜色配置
        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          }
        } else {
          if (res > 0) {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          } else {
            color = "#606266"; // 灰黑色
            new_color = "red";
          }
        }
      } else {
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            typeof this.rule_set.risk_rule?.[param] !== "number" &&
            this.rule_set.risk_rule?.[param].search("%") !== -1
          ) {
            // 阈值类型为百分比: 5%
            if (
              (new_value - old_value) / old_value >
              Number(
                this.rule_set.risk_rule?.[param].substring(
                  0,
                  this.rule_set.risk_rule?.[param].indexOf("%")
                )
              ) *
                0.01
            ) {
              risk = "高风险";
              is_rule = true;
              this.com_risk = "高风险";
            }
          } else {
            // 阈值类型为绝对值: 32
            if (
              new_value - old_value >
              Number(this.rule_set.risk_rule?.[param])
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          }
        }
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 颜色规则
        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          }
        } else {
          if (res > 0) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050"; // 绿色
          }
        }
      }
      // 指标变化规则判断
      if (row) {
        if (res > 0) {
          res = "(" + Math.abs(res) + "↑" + ")";
        } else if (res < 0) {
          res = "(" + Math.abs(res) + "↓" + ")";
        }
      } else {
        if (res > 0) {
          res = Math.abs(res) + "↑";
        } else if (res < 0) {
          res = Math.abs(res) + "↓";
        }
      }
    } else {
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准, 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      } else {
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      }
      res = row ? "(--)" : "";
    }

    if (risk === "高风险" && row) {
      row[param] = "高风险";
      if (!this.report_set.content.red_only_change_value) {
        style = "color: red; font-weight: bold;";
      }
      if (is_rule) {
        color = "red;font-weight: bold;";
      }
    } else {
      risk = "低风险";
    }
    if (this.report_set.content.core_color_rule) {
      // 核心指标标红规则, 变差就标红
      color = new_color;
    }
    // [差值, 风险, 核心表格差值颜色, 核心表格原值颜色, 详情表格差值颜色]
    return [res, risk, color, style, new_color];
  }
  public get get_hero_skin_config() {
    return readHeroSkin(store);
  }
  public get get_scene_chinese() {
    return (
      this.scene_options.filter(
        (item) => item.scene_id === this.selected_scene
      )[0]?.chinese || "-"
    );
  }
  // 获取是否是moba项目
  public get is_in_moba_project() {
    const moba = readMobaProjects(store);
    return moba;
  }
  // 项目是否是王者荣耀
  public get projectIsKing() {
    //9
    if ((this.is_in_moba_project as any).includes(this.localProject)) {
      return true;
    } else {
      return false;
    }
  }
  public risk = "";
  public new_risk() {
    let list = [];
    this.corePerformance.forEach((v) => {
      this.report_set.content.core_index.forEach((k) => {
        v.data.forEach((m) => {
          if (m[k]) {
            list.push(m[k]);
          }
        });
      });
    });
    if (list.length > 0) {
      this.risk = "高风险";
    } else {
      this.risk = "低风险";
    }
  }
  public get_device_label(devie: string, index: number) {
    if (
      this.projectIsKing &&
      Object.keys(this.get_core_data.all_hero_skins).length !== 0
    ) {
      const hero =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item?.hero_id) ===
            this.get_core_data.all_hero_skins?.[devie]?.hero_id
        )[0]?.hero_name || "未知";
      const skin =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item.hero_id) ===
              this.get_core_data.all_hero_skins?.[devie]?.hero_id &&
            Number(item?.skin_id) ===
              this.get_core_data.all_hero_skins?.[devie]?.skin_id
        )[0]?.skin_name || "经典";
      return devie + "\n" + hero + "-" + skin;
    } else {
      return devie;
    }
  }
  // 获取热力图列表
  public getDiagramList() {
    let list: any[] = [];
    (this.get_core_data.position as any).forEach(function (v: any, index: any) {
      list.push({
        idIndex: index,
        mapName: v.scene,
      });
    });
    return list;
  }
  //场景选项
  public get scene_options() {
    const scene = readLabelReport(store).all_echart_data; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene_id,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  public indexValue = 30;
  public typeValue = true;
  public get scene_options1() {
    const scene = readLabelReport(store).auto_roadmap; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  // 获取场景列表
  public get scene_map_option() {
    const mapList = readLabelReport(store).position;
    let mapSceneOptions: any[] = []; //场景
    for (let i in mapList) {
      mapSceneOptions.push({
        scene_id: mapList[i].scene_id,
        chinese: mapList[i].scene,
      });
    }
    return mapSceneOptions;
  }

  // 获取机型
  public selected_device = "";
  public get Selected_device() {
    let Selected_device: any[] = [];
    this.get_core_data.all_device_id.forEach((element: any, index: any) => {
      Selected_device.push({
        label: this.get_core_data.all_devices[index],
        value: element,
      });
    });
    return Selected_device;
  }
  // 指标选项
  public get target_types() {
    let target_select: any[] = [];
    this.report_set.content.trend_index.forEach((item: any) => {
      target_select.push({
        label: this.get_field(item),
        value: item,
      });
    });
    return target_select;
  }
  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  //点击切换场景时触发
  public async selectSceneChange() {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    if (this.localProject === 8) {
      this.drawcontrastChart();
      this.drawcontrastChart2();
    }
  }
  //   public auto_roadmap=[{a:{device_name: "小米10 Pro",
  // fps: null,
  // trajectory: null},scene:"地铁副本测试"},
  // {a:{device_name: "小米10 Pro",
  // fps: null,
  // trajectory: null},scene:"黑铁"}
  // ]

  public async selectSceneChange1(event: any) {
    let imgList = readLabelReport(store).auto_roadmap.filter(
      (v: any) => v.scene === event
    );
    this.imgData = imgList[0].roadmap;
  }
  // 点击切换机型的时候触发
  public async selectDeviceChange() {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
  }
  //点击切换指标时触发
  public selectChange() {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
  }
  public subChart: any = [];
  //绘制图表准备
  // 原始数据处理
  public get getFPS_RawData() {
    const FPS_RawData: any = (this.get_core_data
      .all_echart_data as any[]).filter(
      (item: any) => item.scene_id === this.selected_scene
    )[0]?.echart_data;
    return FPS_RawData;
    // return FPS_RawData.reverse();
  }
  public get getDeviceSpecs() {
    // 设备列表
    const devices = readDeviceSpecs(store);
    return devices;
  }
  // 绘制图表
  public drawPieChart(index: any, indexes: string) {
    // 数据

    let ordinates: any[] = [];
    // 初始化数据
    if (this.get_core_data.all_echart_data.length > 0) {
      this.getFPS_RawData.series.forEach((item: any[], i: any) => {
        let target_values: any = [];
        item.forEach((item) => {
          target_values.push(item[this.target_types[index].value]);
        });
        ordinates.push({
          name: this.getFPS_RawData.device_names[i],
          type: "line",
          data: target_values,
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
        });
      });

      let yAxisSetting: any = {
        type: "value",
        offset: 10,
        axisLabel: {
          formatter: "{value}",
        },
        scale: true,

        // min: function (value: any) {
        //   return Math.ceil(value.min * 0.9);
        // },
        // max: function (value: any) {
        //   return Math.ceil(value.max * 1.05);
        // },
      };
      if (indexes === "lag_pcnt") {
        yAxisSetting = {
          type: "value",
          offset: 10,
          axisLabel: {
            formatter: "{value}",
          },
          max: function (value: any) {
            return Math.ceil(value.max * 1.05);
          },
        };
      }

      let performance_line: any = document.getElementById(
        "performance_line" + index
      );
      let toolbox: any = {
        feature: {
          saveAsImage: {},
        },
      };
      if ("screenshot" in this.$route.query) {
        toolbox = {};
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(performance_line);
      let PerformanceLineChart = echarts.init(performance_line);
      let option;
      option = {
        title: {
          left: "center",
          textStyle: {
            fontSize: 16,
            fontWeight: "normal",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0],
          // data: devices.map(
          //   (item) =>
          //     this.getDeviceSpecs.filter(
          //       (device) => device.id === item.device_id
          //     )[0]?.model.name
          // ),
          data: this.getFPS_RawData.device_names,
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "20%",
          right: "4%",
          containLabel: true,
        },
        toolbox: toolbox,
        animation: false,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: (this.getFPS_RawData.x_axis_format as any[]).map((item) =>
            item.indexOf("(") !== -1 ? item.split("(")[0] + "]" : item
          ),
          // data: game_versions,
          // offset: 10,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: yAxisSetting,
        series: ordinates,
        judge:
          ordinates.filter((item: any) => item.data.length === 0).length ===
          ordinates.length
            ? true
            : false,
      };
      PerformanceLineChart.setOption(option);
      PerformanceLineChart.resize();
      if (option.judge === true) {
        performance_line.parentNode.parentNode.setAttribute(
          "style",
          "display:none"
        );
        this.subChart.push(index);
      }
      var res_base64 = PerformanceLineChart.getDataURL({
        excludeComponents: ["toolbox"],
      }); //拿到base64 地址，就好下载了。
      let res: any = {};
      res.file_base64 = res_base64;
      res.filename =
        "report" +
        index +
        "_project" +
        this.localProject +
        "_report" +
        this.$route.query.report_id +
        ".png";
      res.scene_chinese = this.scene_options.filter(
        (item) => item.scene_id === this.selected_scene
      )[0].chinese;
      res.indexes = this.get_field(indexes);

      this.resBase64.push(res);
      this.removeDuplicates(this.resBase64);
      //  let  newData = [...this.resBase64]
      //  let  hash = {};
      //  this.resBase64 = newData.reduce(function (item, next) {
      //    hash[next.value] ? '' : hash[next.value] = true && item.push(next);
      //       return item
      //     }, [])

      return PerformanceLineChart;
    }
  }
  public removeDuplicates(arr: any) {
    const result: any = [];
    const duplicatesIndices: any = [];

    // 循环遍历原始数组中的每个项
    arr.forEach((current: any, index: any) => {
      if (duplicatesIndices.includes(index)) return;

      result.push(current);

      // 循环遍历数组中当前项之后的其他项
      for (
        let comparisonIndex = index + 1;
        comparisonIndex < arr.length;
        comparisonIndex++
      ) {
        const comparison = arr[comparisonIndex];
        const currentKeys = Object.keys(current);
        const comparisonKeys = Object.keys(comparison);

        // 检查对象中的键数
        if (currentKeys.length !== comparisonKeys.length) continue;

        // 检查关键字名称
        const currentKeysString = currentKeys.sort().join("").toLowerCase();
        const comparisonKeysString = comparisonKeys
          .sort()
          .join("")
          .toLowerCase();
        if (currentKeysString !== comparisonKeysString) continue;

        // 检查值
        let valuesEqual = true;
        for (let i = 0; i < currentKeys.length; i++) {
          const key = currentKeys[i];
          if (current[key] !== comparison[key]) {
            valuesEqual = false;
            break;
          }
        }
        if (valuesEqual) duplicatesIndices.push(comparisonIndex);
      }
    });

    return result;
  }
  public drawcontrastChart() {
    let trend: any = {};
    var chartDom = document.getElementById("contrast_left") as HTMLElement;
    var contrastChart = echarts.init(chartDom);

    (this.get_core_data.version_comparison_list as any).forEach((v: any) => {
      if (v.scene_id == this.selected_scene) {
        trend = v;
      }
    });

    contrastChart.setOption({
      title: {
        text: "平均FPS",
        textStyle: {
          fontSize: 13,
        },
      },
      xAxis: {
        type: "category",
        data: trend.device_list,
      },
      yAxis: {
        type: "value",
      },
      legend: {
        data: trend.version_list,
      },
      animation: false,
      series: [
        {
          name: trend.version_list[0],
          data: trend.data.avg_fps[0],
          type: "bar",
          label: {
            show: true,
            position: "top",
          },
        },
        {
          name: trend.version_list[1],
          data: trend.data.avg_fps[1],
          type: "bar",
          label: {
            show: true,
            position: "top",
          },
        },
      ],
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "version_compare_fps.png";
    res.scene_chinese = this.scene_options.filter(
      (item) => item.scene_id === this.selected_scene
    )[0].chinese;
    res.indexes = "version_compare_fps";
    this.resBase64.push(res);
  }
  public drawcontrastChart2() {
    let trend: any = {};
    var chartDom = document.getElementById("contrast_right") as HTMLElement;
    var contrastChart = echarts.init(chartDom);
    (this.get_core_data.version_comparison_list as any).forEach((v: any) => {
      if (v.scene_id == this.selected_scene) {
        trend = v;
      }
    });
    contrastChart.setOption({
      title: {
        text: "MaxPss",
        textStyle: {
          fontSize: 13,
        },
      },
      xAxis: {
        type: "category",
        data: trend.device_list,
      },
      yAxis: {
        type: "value",
      },
      animation: false,
      legend: {
        data: trend.version_list,
      },
      series: [
        {
          name: trend.version_list[0],
          data: trend.data.max_pss[0],
          type: "bar",
          label: {
            show: true,
            position: "top",
          },
        },
        {
          name: trend.version_list[1],
          data: trend.data.max_pss[1],
          type: "bar",
          label: {
            show: true,
            position: "top",
          },
        },
      ],
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "version_compare_pss.png";
    res.scene_chinese = this.scene_options.filter(
      (item) => item.scene_id === this.selected_scene
    )[0].chinese;
    res.indexes = "version_compare_pss";
    this.resBase64.push(res);
  }

  //报告筛选部分
  //风险等级
  public indexOption = ["平均FPS", "峰值PSS", "平均CPU", "卡顿率"];
  public status_search: string | "" = "";
  public status_options = [
    {
      label: "高风险",
      value: "高风险",
    },
    {
      label: "低风险",
      value: "低风险",
    },
  ];
  //报告名称
  public name_search = "";
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  // 编辑
  public dialogFormVisible1 = false;
  public formLabelWidth = "";
  public form1 = {
    name: "",
  };
  public selected_scene2 = "";
  public selected_scene3 = "";
  public selected_scene4 = "";
  public sceneModelOption = [];
  // 核心场景机型选择
  // public selectSceneChange2() {
  //   console.log(this.get_core_data.position);
  //   console.log(this.selected_scene2);
  //   let sceneModel1 = this.get_core_data.position.filter(
  //     (v: any) => v.scene_id == Number(this.selected_scene2)
  //   );

  //   let selectList = (sceneModel1[0] as any).position;
  //   let sceneModelList: any = [];
  //   for (let i in selectList) {
  //     sceneModelList.push({
  //       scene_id: selectList[i].device_id,
  //       chinese: selectList[i].device,
  //     });
  //   }

  //   this.sceneModelOption = sceneModelList;
  //   let sceneId = this.selected_scene2;
  //   let sceneModel = this.selected_scene3;
  //   let indexName = this.selected_scene4;
  //   this.drawMap(sceneId, sceneModel, indexName, this.indexValue);
  // }

  public async selectSceneChange3() {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    await this.getDiagramList().map((v: any) => {
      if (this.typeValue == true) {
        this.fal = true;
        this.fal1 = false;
      } else {
        this.fal1 = true;
        this.fal = false;
      }
      this.$nextTick(() => {
        this.drawMap3(
          v.mapName,
          v.idIndex,
          this.selected_scene4,
          this.indexValue,
          this.selected_scene3,
          this.typeValue
        );
      });
    });
  }
  public async selectSceneChange4(value: any) {
    if (value === "峰值PSS") {
      this.indexValue = 2000;
    }
    if (value === "平均CPU") {
      this.indexValue = 70;
    }

    // let sceneId = this.selected_scene2;
    // let sceneModel = this.selected_scene3;
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    let indexName = this.selected_scene4;
    await this.getDiagramList().map((v: any) => {
      if (this.typeValue == true) {
        this.fal = true;
        this.fal1 = false;
      } else {
        this.fal1 = true;
        this.fal = false;
      }
      this.$nextTick(() => {
        this.drawMap3(
          v.mapName,
          v.idIndex,
          this.selected_scene4,
          this.indexValue,
          this.selected_scene3,
          this.typeValue
        );
      });
    });
    // this.drawMap(sceneId, sceneModel, indexName, this.indexValue);
  }
  // public showEdit(){
  //   this.dialogFormVisible1 = true;
  //   console.log(this.name_search)
  //   this.form1.name=(readNewReportList(store) as any[]).filter(
  //       (item: any) => item.id === this.name_search
  //     )[0].report_name;
  // }
  public handleEdit() {
    this.dialogFormVisible1 = true;
    this.form1.name = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // this.form1.name=edit_name.slice(0,edit_name.indexOf('】')+1)
  }

  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchUpdateReport(store, {
      project: this.localProject,
      id: Number(this.name_search),
      report_name: String(this.form1.name),
    });
    (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name = this.form1.name;
  }
  // 邮件
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  // 复制数据
  public copyVal = {
    taskRecordId: "", //任务记录id
    deviceVal: "", //任务记录设备
  };
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  // 点击删除
  public async handleDelete() {
    this.loading = true;

    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
      page: 1,
      size: 1,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });
    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });

    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    //调用获取性能报告接口
    await dispatchGetLabelReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    if (this.localProject === 8) {
      this.drawcontrastChart();
      this.drawcontrastChart2();
    }
    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }
    this.judgeModel();

    // await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();
    this.new_risk();
    await this.scrollBar(); //判断是否有滚动条

    this.loading = false;
  }

  public get screenshot() {
    if ("screenshot" in this.$route.query) {
      return false;
    } else {
      return true;
    }
  }

  public resBase64: any[] = [];
  //发送报告
  public save_report(is_auto?: boolean) {
    let upload_data: any;
    if (typeof is_auto === "boolean") {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.removeDuplicates(this.resBase64),
        is_auto: is_auto,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        send: this.formMail.Sender,
        report_type: 7,
      };
    } else {
      upload_data = {
        // project: Number(this.$route.query.project),
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.removeDuplicates(this.resBase64),
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        send: this.formMail.Sender,
        report_type: 7,
      };
    }

    dispatchUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  public async clear() {
    this.loading = true;
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    // await dispatchGetReportDetail(store, {
    //   project: this.localProject,
    //   id: readNewReportList(store)[0].id,
    // });
    //调用获取性能报告接口

    await dispatchGetLabelReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    if (this.report_set.content.trend_scene) {
      if (this.report_set.content.trend_scene.length !== 0) {
        this.selected_scene = this.report_set.content.trend_scene[0];
      }
    }
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    this.corePerformance = [];
    await this.getCorePerformance();
    this.new_risk();
    this.loading = false;
  }
  // 判断安卓/ios
  public modelVal = "安卓";
  public judgeModel() {
    let ad_new = this.get_core_data.able_versions.android_new_version;
    let ad_old = this.get_core_data.able_versions.android_old_version;
    let ios_new = this.get_core_data.able_versions.ios_new_version;
    let ios_old = this.get_core_data.able_versions.ios_old_version;
    if (
      (ad_new !== "" || ad_old !== "") &&
      (ios_new !== "" || ios_old !== "")
    ) {
      this.modelVal = "安卓/iOS";
    } else if (ios_new !== "" || ios_old !== "") {
      this.modelVal = "iOS";
    }
    return this.modelVal;
  }

  // 链接
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }

  // 获取所有的索引
  public all_index(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexs = [];
    indexs.push(...index.basic);
    indexs.push(...index.advance);
    indexs.push(...index.customize);
    indexs.push(...custom_index);
    return indexs;
  }

  // 索引分类
  public indexClassification(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexClassification: any[] = [];
    indexClassification.push({
      indexClassification: "指标分类",
      dataItem: "数据项",
    });
    (index.basic as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "基础指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    (index.advance as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "深度指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    (index.customize as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    custom_index.forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: item,
        style: { "background-color": "#5d99d5" },
      })
    );
    return indexClassification;
  }
  public time: any = "";
  public reload() {
    this.time = new Date().getTime();
  }
  // 判断是否出现滚动条
  public scroll = false;
  public scrollBar() {
    let obj = document.getElementById("Table_Right_div");
    if (
      this.get_core_data.report_list2.length > 0 &&
      (obj as any).offsetHeight - (obj as any).clientHeight > 0
    ) {
      this.scroll = true;
    } else {
      this.scroll = false;
    }
  }

  // 解析邮件收件人
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }

  // 报告名称切换时
  public async change_name_search() {
    this.loading = true;
    // 获取当前报告名称列表
    // await dispatchGetNewReportList(store, { project: this.localProject });
    // 报告名称
    // this.name_search = readNewReportList(store)[0].id;
    // 邮件标题
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    //调用获取性能报告接口
    await dispatchGetLabelReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    if (this.report_set.content.trend_scene) {
      if (this.report_set.content.trend_scene.length !== 0) {
        this.selected_scene = this.report_set.content.trend_scene[0];
      }
    }
    if (this.get_core_data.auto_roadmap != undefined) {
      this.selected_scene1 =
        (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
      this.imgData = readLabelReport(store).auto_roadmap[0]?.roadmap;
      // this.imgData=[{device_name: "19X",fps: "../../assets/performance/footer.png",trajectory: "",}]
    }
    if (
      this.get_core_data.position.length > 0 &&
      this.get_core_data.position != undefined
    ) {
      // this.selected_scene2 = (this.get_core_data.position[0] as any)?.scene_id;
      // let sceneModelList: any = [];
      // sceneModelList.push({
      //   scene_id: (this.get_core_data.position[0] as any)?.position[0]
      //     .device_id,
      //   chinese: (this.get_core_data.position[0] as any)?.position[0].device,
      // });

      // this.sceneModelOption = sceneModelList;
      // this.selected_scene3 = (
      //   this.get_core_data.position[0] as any
      // )?.position[0]?.device_id;
      this.selected_scene3 = (this.get_core_data.device_options[0] as any).id;
      this.selected_scene4 = this.indexOption[0];
    }
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
      this.target_types.map((item, index) => {
        this.drawPieChart(index, item.value);
        let performanceTrends: any = document.getElementById(
          "performance_line" + index
        );
        if (performanceTrends.children.length === 0) {
          performanceTrends.parentNode.parentNode.parentNode.style.display =
            "none";
          // performanceTrends.parentNode.style.display="block"
        } else {
          performanceTrends.parentNode.parentNode.parentNode.style.display =
            "block";
        }
      });
    });

    // await this.drawMap(
    //   this.selected_scene2,
    //   this.selected_scene3,
    //   this.selected_scene4,
    //   this.indexValue
    // );
    await this.getDiagramList().map((v: any) => {
      if (this.typeValue == true) {
        this.fal = true;
        this.fal1 = false;
      } else {
        this.fal1 = true;
        this.fal = false;
      }
      this.$nextTick(() => {
        this.drawMap3(
          v.mapName,
          v.idIndex,
          this.selected_scene4,
          this.indexValue,
          this.selected_scene3,
          this.typeValue
        );
      });
    });
    if (this.localProject === 8) {
      this.drawcontrastChart();
      this.drawcontrastChart2();
    }

    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }
    this.judgeModel();

    await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();
    this.new_risk();
    this.loading = false;
  }
  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public dialogFormVisibleByTask = false; // 生成报告的弹窗是否可见
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
  };

  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称

  // 打开生成报告
  public generateReportsManually() {
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-新版本号";
  }
  public generateReportsManuallyByTask() {
    this.dialogFormVisibleByTask = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  //获取下拉选择选项
  // public get getPerformanceSelectOptions() {
  //   return readPerformanceSelectOptions(store);
  // }
  public get getDateVersions() {
    return readDateVersions(store);
  }
  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    // const versions = this.getPerformanceSelectOptions.game_versions; //获取性能选择选项里的有些版本
    const versions = this.getDateVersions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item.value) {
        game_version_select.push({
          label: item.label,
          value: item.value,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }
  // 生成报告
  public async generateReport() {
    if (
      this.generateReportVersion.oldEdition === "" ||
      this.generateReportVersion.newEdition === ""
    ) {
      alert("版本号不能为空哦！");
      return;
    }
    // if (
    //   this.generateReportVersion.oldEdition ===
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("版本号不能相同哦！");
    //   return;
    // }
    // if (
    //   this.generateReportVersion.oldEdition >
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("新版本号不能小于旧版本！");
    //   return;
    // }
    this.loading = true;
    this.dialogFormVisible = false;
    await dispatchCreateReport(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      new_version: this.generateReportVersion.newEdition.split("|")[0],
      old_version: this.generateReportVersion.oldEdition.split("|")[0],
      timestamp: this.generateReportVersion.newEdition.split("|")[1],
      old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
      // report_name: this.report_name_placeholder,
      scene_list: this.generateReportVersion.scenetion,
    });

    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });
    // 报告名称

    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口
    await dispatchGetLabelReport(store, {
      project: this.localProject,
      report_id: readNewReportList(store)[0].id,
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    if (this.report_set.content.trend_scene) {
      if (this.report_set.content.trend_scene.length !== 0) {
        this.selected_scene = this.report_set.content.trend_scene[0];
      }
    }
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    if (this.localProject === 8) {
      this.drawcontrastChart();
      this.drawcontrastChart2();
    }
    this.judgeModel();

    await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();
    this.new_risk();
    this.loading = false;
    this.dialogFormVisible = false;
  }
  public fal = false;
  public fal1 = true;
  // 生成报告
  public async generateReportByTask() {
    this.loading = true;
    this.dialogFormVisibleByTask = false;
    await dispatchCreateReportByTask(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      task_record_id: Number(this.generateReportVersion.newEdition),
      old_record_id: Number(this.generateReportVersion.oldEdition),
      // report_name: this.report_name_placeholder,
      // allow: this.contrast,
    });

    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });
    // 报告名称
    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口
    await dispatchGetLabelReport(store, {
      project: this.localProject,
      report_id: readNewReportList(store)[0].id,
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    if (this.report_set.content.trend_scene) {
      if (this.report_set.content.trend_scene.length !== 0) {
        this.selected_scene = this.report_set.content.trend_scene[0];
      }
    }
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    if (this.localProject === 8) {
      this.drawcontrastChart();
      this.drawcontrastChart2();
    }
    this.judgeModel();

    await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();
    this.new_risk();
    this.loading = false;
  }

  // 激活报告名称
  // public activation(val: boolean) {
  //   if (val) {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition;
  //   } else {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition.split("|")[0];
  //   }
  // }

  // 得到项目名称
  public get get_project_name() {
    const project_name = readProjectDetail(store).project_name;
    return project_name;
  }

  public drawMap3(
    item: any,
    index: any,
    indexName: any,
    indexvalue: any,
    modelID: any,
    type: boolean
  ) {
    if (this.get_core_data.position?.length > 0) {
      if (type == true) {
        var chartDom = document.getElementById("map" + item) as HTMLElement;
        var contrastChart = echarts.init(chartDom);
        let indexMap = 0;
        if (this.indexOption.indexOf(indexName) != -1) {
          indexMap = this.indexOption.indexOf(indexName) + 2;
        }
        // let dataAll=[]
        const data = (this.get_core_data.position[index] as any).position
          .filter((v: any) => v.device_id == modelID)[0]
          ?.data_chart.map(function (item: any) {
            return [item[1], item[0], item[indexMap] || "-"];
          });
        //  if (indexvalue.length > 0) {
        //   if (this.indexOption.indexOf(indexName) == 0) {
        //     dataAll = data.filter((v: any) => v[2] >= indexvalue);
        //   } else {
        //     dataAll = data.filter((v: any) => v[2] <= indexvalue);
        //   }
        // } else if (indexvalue.length == 0) {
        //   dataAll = data;
        // }

        const hours = (this.get_core_data.position[
          index
        ] as any).position.filter((v: any) => v.device_id == modelID)[0]
          ?.x_axis;
        // prettier-ignore
        const days = (this.get_core_data.position[index] as any).position.filter((v:any)=>v.device_id==modelID)[0]?.y_axis;
        let fullImage = new Image();
        let img = new Image();
        let labelShow = true;
        let min = 0;
        let max = 0;
        let imgColor = [];
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");

        canvas.width = contrastChart.getWidth() * window.devicePixelRatio;
        canvas.height = contrastChart.getHeight() * window.devicePixelRatio;
        img.onload = () => {
          (ctx as any).drawImage(img, 0, 0, canvas.width, canvas.height);
          fullImage.src = canvas.toDataURL();
          contrastChart.resize();
        };
        if (item.indexOf("森林") != -1) {
          img.src = require("../../assets/test/003.jpg");
        } else if (item.indexOf("航天") != -1) {
          img.src = require("../../assets/test/006.jpg");
        } else if (item.indexOf("cracked") != -1) {
          img.src = require("../../assets/test/005.jpg");
        } else {
          img.src = require("../../assets/test/002.jpg");
        }

        if (indexName === "平均FPS") {
          labelShow = true;
          max = indexvalue;
          min = Number(max) - 1;
          imgColor = ["rgba(255,0,0,0.5)", "rgba(0,255,0,0.5)"];
        } else {
          labelShow = false;
          min = indexvalue;
          max = Number(min) + 1;
          imgColor = ["rgba(0,255,0,0.5)", "rgba(255,0,0,0.5)"];
        }
        // console.log(min, max);

        // let min = this.getMinMaxOf2DIndex(data, 2).min;
        // let max = this.getMinMaxOf2DIndex(data, 2).max;
        let option = {};
        option = {
          // title: {
          //   text: item
          // },
          animation: false,
          backgroundColor: {
            image: fullImage,
            repeat: "no-repeat",
          },
          tooltip: {
            position: "top",
            // formatter: function (params: any, ticket: any, callback: any) {
            //   console.log(params);
            //   var showHtm = "";
            //   console.log(1);

            //   // return `<div>${params.seriesName}:${params.data[2]}</div>`;
            //   return <img src="../../assets/test/2.jpg"/>;
            // },
            formatter: function (params: any) {
              return `<div>${params.seriesName}:${params.data[2]}</div>`;
              //         console.log(params);
              //           var str = `<div style = "background:url( ${require("../../assets/test/8.jpg")}) no-repeat center center ;width:60px;height:60px; "></div>`;

              // console.log(str);
              // return str;
              //  return  `<div style="display:flex"><div style = "background:url(${require("../../assets/test/8.jpg")}) no-repeat center center ;width:200px;height:200px;margin-right:10px;background-size:100% 100% "></div><div style = "background:url(${require("../../assets/test/9.jpg")}) no-repeat center center ;width:200px;height:200px;background-size:100% 100% "></div></div>`

              // <div>

              // `;
            },
          },
          grid: {
            x: 0,
            y: 0,
            x2: 0,
            y2: 0,
          },
          xAxis: {
            type: "category",
            data: hours,
            // splitArea: {
            //   show: true,
            // },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },

            // show: false
          },
          yAxis: {
            type: "category",
            data: days,
            splitArea: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },

            // show: false
          },

          visualMap: {
            min: min,
            max: max,
            calculable: true,
            orient: "horizontal",
            // left: 'center',
            // splitNumber: 2,
            bottom: "15%",
            show: false,
            inRange: {
              color: imgColor,
            },
          },
          series: [
            {
              name: indexName,
              type: "heatmap",
              data: data,
              label: {
                show: labelShow,

                textStyle: {
                  fontSize: 12,
                  fontWeight: "bold",
                  color: "#fff",
                },
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  // shadowColor: ['#ff0','#f00'],
                },
              },
            },
          ],
        };

        contrastChart.setOption(option);
        // var res_base64 = contrastChart.getDataURL({
        //   excludeComponents: ["toolbox"],
        // }); //拿到base64 地址，就好下载了。
        // let res: any = {};
        // res.file_base64 = res_base64;
        // res.filename = "position" + item + ".png";
        // res.scene_chinese = item;
        // res.indexes = indexName;
        // this.resBase64.push(res);
      } else {
        this.drawTest(item, index, indexName, indexvalue, modelID);
      }
    }
  }
  // 热力图
  //   public drawMap(scid: any, sceneModel: any, indexName: any, indexvalue: any) {
  //     if (this.get_core_data.position?.length > 0) {
  //       let MapList = (
  //         this.get_core_data.position?.filter(
  //           (v: any) => v.scene_id == scid
  //         )[0] as any
  //       ).position?.filter((item: any) => item.device_id == sceneModel)[0];
  //       console.log(MapList);
  //       var chartDom = document.getElementById("map") as HTMLElement;
  //       var contrastChart = echarts.init(chartDom);
  //       // const hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39]
  //       const hours = MapList.x_axis;
  //       // prettier-ignore
  //       const days = MapList.y_axis
  //       console.log(hours, days);
  //       // prettier-ignore
  //       //     const data = (this.get_core_data.position[0] as any).position[0].data_chart
  //       //     .map(function (item:any) {
  //       //     return [item[1], item[0], item[2] || '-'];
  //       // });
  //       let indexMap=0
  //       if (this.indexOption.indexOf(indexName) != -1) {
  //         indexMap = this.indexOption.indexOf(indexName) + 2;
  //       }

  //       console.log(indexMap);
  //       let dataALL = [];
  //       const data = MapList.data_chart.map(function (item: any) {
  //         console.log(indexMap);
  //         return [item[1], item[0], item[indexMap] || "-"];
  //       });
  //       if (indexvalue.length > 0) {
  //         if (this.indexOption.indexOf(indexName) == 0) {
  //           dataALL = data.filter((v: any) => v[2] >= indexvalue);
  //         } else {
  //           dataALL = data.filter((v: any) => v[2] <= indexvalue);
  //         }
  //       } else if (indexvalue.length == 0) {
  //         dataALL = data;
  //       }
  //       console.log(dataALL);
  //       // 自适应尺寸 如果不写就会造成画布图片对不齐问题
  //       let fullImage = new Image();
  //       let img = new Image();
  //       let canvas = document.createElement("canvas");
  //       let ctx = canvas.getContext("2d");
  //       canvas.width = contrastChart.getWidth() * window.devicePixelRatio;
  //       canvas.height = contrastChart.getHeight() * window.devicePixelRatio;
  //       img.onload = () => {
  //         (ctx as any).drawImage(img, 0, 0, canvas.width, canvas.height);
  //         fullImage.src = canvas.toDataURL();
  //         contrastChart.resize();
  //       };
  //       img.src = require("../../assets/test/002.jpg");
  //       console.log(this.getMinMaxOf2DIndex(data, 2));
  //       let min = this.getMinMaxOf2DIndex(data, 2).min;
  //       let max = this.getMinMaxOf2DIndex(data, 2).max;

  //       let option = {};
  //       option = {
  //         backgroundColor: {
  //           image: fullImage,
  //           repeat: "no-repeat",
  //         },
  //         tooltip: {
  //           position: "top",
  //           // formatter: function (params: any, ticket: any, callback: any) {
  //           //   console.log(params);
  //           //   var showHtm = "";
  //           //   console.log(1);

  //           //   // return `<div>${params.seriesName}:${params.data[2]}</div>`;
  //           //   return <img src="../../assets/test/2.jpg"/>;
  //           // },
  //           formatter: function (params: any) {
  //              return `<div>${params.seriesName}:${params.data[2]}</div>`;
  //     //         console.log(params);
  //     //           var str = `<div style = "background:url( ${require("../../assets/test/8.jpg")}) no-repeat center center ;width:60px;height:60px; "></div>`;

  //     // console.log(str);
  //     // return str;
  //   //  return  `<div style="display:flex"><div style = "background:url(${require("../../assets/test/8.jpg")}) no-repeat center center ;width:200px;height:200px;margin-right:10px;background-size:100% 100% "></div><div style = "background:url(${require("../../assets/test/9.jpg")}) no-repeat center center ;width:200px;height:200px;background-size:100% 100% "></div></div>`

  // // <div>

  // // `;
  //           },
  //         },
  //         grid: {
  //           x: 0,
  //           y: 0,
  //           x2: 0,
  //           y2: 0,
  //         },
  //         xAxis: {
  //           type: "category",
  //           data: hours,
  //           // splitArea: {
  //           //   show: true,
  //           // },
  //           axisLine: {
  //             lineStyle: {
  //               color: "#fff",
  //             },
  //           },

  //           // show: false
  //         },
  //         yAxis: {
  //           type: "category",
  //           data: days,
  //           splitArea: {
  //             show: true,
  //           },
  //           axisLine: {
  //             lineStyle: {
  //               color: "#fff",
  //             },
  //           },

  //           // show: false
  //         },

  //         visualMap: {
  //           min: min,
  //           max: max,
  //           calculable: true,
  //           orient: "horizontal",
  //           // left: 'center',
  //           // splitNumber: 2,
  //           bottom: "15%",
  //           show: false,
  //           inRange: {
  //             color: [
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(0,255,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //               "rgba(255,0,0,0.5)",
  //             ],
  //           },
  //         },
  //         series: [
  //           {
  //             name: indexName,
  //             type: "heatmap",
  //             data: dataALL,
  //             label: {
  //               show: true,

  //               textStyle: {
  //                 fontSize: 6,
  //                 fontWeight: "bold",
  //                 color: "#fff",
  //               },
  //             },
  //             emphasis: {
  //               itemStyle: {
  //                 shadowBlur: 10,
  //                 // shadowColor: ['#ff0','#f00'],
  //               },
  //             },
  //           },
  //         ],
  //       };

  //       contrastChart.setOption(option);
  //     }
  //   }
  //显示文字
  public getShow(indexName: any) {
    if (indexName == "平均FPS") {
      return "FPS>=";
    }
    if (indexName == "峰值PSS") {
      return "PSS<=";
    }
    if (indexName == "平均CPU") {
      return "CPU<=";
    }
    if (indexName == "卡顿率") {
      return "卡顿率<=";
    }
  }

  // 切换复制的id时，更新设备数据
  public async equipmentUpdate() {
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
  }

  // 获取复制需要的任务id下拉框
  public get TaskRecordQuery() {
    return readTaskRecordQuery(store);
  }

  // 获取复制需要的设备数据下拉框
  public get TaskRecordDevices() {
    return readTaskRecordDevices(store);
  }

  //复制的接口
  public async CopyBtn() {
    this.loading = true;
    let copy = {
      project: this.localProject,
      task_record_id: this.copyVal.taskRecordId,
      device_id: this.copyVal.deviceVal,
      report_id: Number(this.$route.query.report_id),
    };
    await dispatchAovCopyPerfToReport(store, copy);
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口

    await dispatchGetLabelReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    if (this.report_set.content.trend_scene) {
      if (this.report_set.content.trend_scene.length !== 0) {
        this.selected_scene = this.report_set.content.trend_scene[0];
      }
    }
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    this.corePerformance = [];
    await this.getCorePerformance();
    this.new_risk();
    this.loading = false;
  }
  public blurUsername(value: any) {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    this.getDiagramList().map((v: any) => {
      if (this.typeValue == true) {
        this.fal = true;
        this.fal1 = false;
      } else {
        this.fal1 = true;
        this.fal = false;
      }
      this.$nextTick(() => {
        this.drawMap3(
          v.mapName,
          v.idIndex,
          this.selected_scene4,
          this.indexValue,
          this.selected_scene3,
          this.typeValue
        );
      });
    });
  }
  public old_text() {
    // if(readPerfReport(store).able_versions.android_old_version!=='' && readPerfReport(store).able_versions.ios_old_version==''){
    //   return 'android:'+readPerfReport(store).able_versions.android_old_version
    // }else if(readPerfReport(store).able_versions.android_old_version=='' && readPerfReport(store).able_versions.ios_old_version!==''){
    //    return 'ios'+readPerfReport(store).able_versions.ios_old_version
    // }
    let androidOld = readLabelReport(store).able_versions?.android_old_version;
    let iosOld = readLabelReport(store).able_versions?.ios_old_version;
    if (androidOld !== "" && iosOld == "") {
      return androidOld;
    }
    if (androidOld == "" && iosOld !== "") {
      return iosOld;
    }
    if (androidOld == "" && iosOld == "") {
      return "";
    } else if (androidOld !== "" && iosOld !== "") {
      return "android:" + androidOld + ",ios:" + iosOld;
    }
  }
  public typeChange(value: any) {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
    this.getDiagramList().map((v: any) => {
      if (this.typeValue == true) {
        this.fal = true;
        this.fal1 = false;
      } else {
        this.fal1 = true;
        this.fal = false;
      }
      this.$nextTick(() => {
        this.drawMap3(
          v.mapName,
          v.idIndex,
          this.selected_scene4,
          this.indexValue,
          this.selected_scene3,
          this.typeValue
        );
      });
    });
  }
  // 复制接口禁用
  public get interfaceDisabled() {
    let disabled = false;
    if (
      this.get_is_super ||
      this.copyVal.taskRecordId === "" ||
      this.copyVal.deviceVal === "" ||
      this.copyVal.deviceVal === undefined
    ) {
      disabled = true;
    }
    return disabled;
  }
  // 计算二维数组第三个数最大最小值
  public getMinMaxOf2DIndex(arr: any, idx: any) {
    return {
      min: Math.min.apply(
        null,
        arr.map(function (e: any) {
          return e[idx];
        })
      ),
      max: Math.max.apply(
        null,
        arr.map(function (e: any) {
          return e[idx];
        })
      ),
    };
  }
}
